import React from 'react';
import Slider from 'react-slick';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import ArrowForward from 'material-ui/svg-icons/navigation/arrow-forward';

import { safeCredentials, handleErrors } from '../../utils/fetchHelpers';
import inView from '../../utils/inView';

import '!style-loader!css-loader!slick-carousel/slick/slick.css';
import '!style-loader!css-loader!slick-carousel/slick/slick-theme.css';
import './StorySlider.scss';

class StorySlider extends React.Component {
  state = {
    load: false,
    activeSlide: 0,
    stories: [],
  };

  componentDidMount() {
    fetch('/api/v2/stories?num=12', safeCredentials({}))
    .then(handleErrors)
    .then(res => {
      this.setState({
        stories: res.data,
      })
    });
    inView.offset(-100);
    inView('#storySlider').once('enter', () => { this.setState({ load: true }) });
  }

  sliderSettings = {
    arrows: false,
    speed: 200,
    infinite: true,
    swipe: false,
    draggable: false,
    autoplaySpeed: 7000,
    autoplay: true,
    pauseOnHover: true,
    pauseOnFocus: true,
    adaptiveHeight: true,
    beforeChange: (current, next) => this.setState({ activeSlide: next }),
  };

  render() {
    const { activeSlide, stories, load } = this.state;
    if (stories.length === 0 || load === false) {
      return <div className="rounded boxshadowLight bg-white d-flex flex-column text-center justify-content-center" id="storySlider" style={{ height: '200px' }}><h3>Student stories loading...</h3></div>;
    }
    return (
      <div className="storySlider" id="storySlider">
        <div className='mb-4 slider-container'>
          <div className="d-flex flex-column flex-sm-row rounded boxshadowLight bg-white">
            <div className="bgContainer">
              {stories.map((story, index) => (
                <div key={story.id.$oid} className={`bg ${index === activeSlide ? 'active' : ''}`} style={{ backgroundImage: `url('${story.attributes.thumbnail_link.replace('/original', '/medium')}')` }} />
              ))}
            </div>
            <Slider ref={(c) => { this.slider = c; }} {...this.sliderSettings}
              className='storiesSlider align-self-center slider'
            >
              {stories.map((story, index) => (
                <div key={story.id.$oid} className={`story, ${index === activeSlide ? 'active' : ''}`}>
                  <div className='p-3 text-center text-sm-left inner'>
                    <p><b>Student Story</b></p>

                    <div className='mt-2 mb-3' style={{fontSize: "1.2em"}}>
                      "{story.attributes.title}"
                    </div>
                    <div>
                      <a href={`/stories/@${story.relationships.profile.data.attributes.username}`} className="inlineLink">Read {story.relationships.profile.data.attributes.first_name}&#39;s Story</a>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          <FloatingActionButton mini={true} className='floatingActionButton prev' backgroundColor="#fff" onClick={() => { this.slider.slickPrev(); }}>
            <ArrowBack style={{fill: '#444'}} />
          </FloatingActionButton>
          <FloatingActionButton mini={true} className='floatingActionButton next' backgroundColor="#fff" onClick={() => { this.slider.slickNext(); }}>
            <ArrowForward style={{fill: '#444'}} />
          </FloatingActionButton>
        </div>
        <div className="d-flex justify-content-center">
          {stories.map((story, index) => (
            <div key={story.id.$oid} className={`rounded-circle mx-md-1 hovercraft thumb ${index === activeSlide ? 'active' : ''}`} style={{ backgroundImage: `url('${story.attributes.thumbnail_link.replace('/original', '/thumbnail')}')` }}
              onClick={() => { this.slider.slickGoTo(index); }}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default StorySlider;
